import 'react-native-gesture-handler';
import { AppRegistry } from 'react-native';
import App from '../rnapp';

// Polyfill `Promise.allSettled` for TVs running Chromium <76. Our target
// floor is Chromium 76 (Tizen 5.5 / WebOS 5 / Android TV 10), where it
// landed natively — but some TV builds lag the official Chromium release
// they advertise, so a 12-line shim is cheap insurance.
if (typeof Promise !== 'undefined' && !(Promise as any).allSettled) {
  (Promise as any).allSettled = function <T>(
    promises: Array<Promise<T> | T>,
  ): Promise<
    Array<
      | { status: 'fulfilled'; value: T }
      | { status: 'rejected'; reason: unknown }
    >
  > {
    return Promise.all(
      promises.map((p) =>
        Promise.resolve(p).then(
          (value) => ({ status: 'fulfilled' as const, value }),
          (reason) => ({ status: 'rejected' as const, reason }),
        ),
      ),
    );
  };
}

// On Tizen/WebOS/Web the RNV index.html template doesn't set a height on
// html/body/#root, so React Native Web's `flex: 1` collapses to content
// height and the app renders in only the top portion of the screen.
// Inject the height + reset rules before the app mounts.
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    html, body, #root {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
      overflow: hidden;
      background: #FFF4E6;
    }
    body { -webkit-font-smoothing: antialiased; }
  `;
  document.head.appendChild(style);
}

AppRegistry.registerComponent('RNVApp', () => App);
AppRegistry.runApplication('RNVApp', {
  rootTag: document.getElementById('root'),
});
